import * as React from "react";

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24 } = props;
  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      viewBox="-4 0 32 24"
      fill="none"
    >
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M-4 0H28V24H-4V0Z"
          fill="#E30A17"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.35 12.3749C16.35 15.6849 13.62 18.3699 10.25 18.3699C6.88002 18.3699 4.15002 15.6849 4.15002 12.3699C4.15002 9.05488 6.88002 6.37988 10.25 6.37988C13.62 6.37988 16.35 9.06488 16.35 12.3749Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.65 12.3751C16.65 15.0251 14.47 17.1701 11.775 17.1701C9.08002 17.1701 6.89502 15.0201 6.89502 12.3701C6.89502 9.72008 9.08002 7.58008 11.775 7.58008C14.47 7.58008 16.655 9.72508 16.655 12.3751H16.65Z"
          fill="#E30A17"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.535 9.57507L17.485 11.7901L15.42 12.3501L17.46 13.0751L17.41 15.1101L18.735 13.5201L20.745 14.2201L19.585 12.5151L21 10.8201L18.825 11.4201L17.535 9.57007V9.57507Z"
          fill="white"
        />
      </g>
    </svg>
  );
}

export default SvgComponent;
